import React from 'react';
import './FieldWithLabel.scss';

export default function FieldWithLabel({
  component,
  label,
  hideDivider = false,
  className = '',
  subLabel,
}) {
  return (
    <>
      {!hideDivider && <hr className='hr_divider' />}
      <div className={'labeled-field-wrapper '.concat(className)}>
        <div className='labeled-field__label-wrapper'>
          <label className='labeled-field__label'>{label}</label>
          <span className='labeled-field__sub-label'>{subLabel}</span>
        </div>
        <div className='labeled-field__component'>{component}</div>
      </div>
    </>
  );
}
